// imports
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LINKS, ROUTES } from '../../constants';

// interfaces / types / consts
interface Props {
  text?: string;
  linkType?: 'opensea' | 'heroreserve';
}

// exports
export default function EmptyList(props: Props): JSX.Element {
  const { text, linkType } = props;
  const navigate = useNavigate();
  return (
    <div className="empty-list">
      <div className="inventory-text">
        <div className="label">
          {text || (
            <div>
              {linkType === 'opensea' ? (
                <div>
                  Get heroes on&nbsp;
                  <button type="button" onClick={() => window.open(LINKS.OPEN_SEA_COLLECTION_IMMORTALS, '_blank')}>OpenSea</button>
                  &nbsp;to play Skyborne Genesis.
                </div>
              ) : (
                <div>
                  Go to&nbsp;
                  <button type="button" onClick={() => navigate(ROUTES.HERO_COLLECTION, { state: { defaultTab: 'reserve' } })}>Hero Reserve</button>
                  &nbsp;to activate your heroes.
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// default props
EmptyList.defaultProps = { text: '', linkType: 'opensea' };
